import { ViewModel,View, ObservableArray } from "binder"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { AccountSelectorViewModel, CachedAccountLoader, IAccountLoader } from "../../rawData/accountSelector/accountSelector-viewModel";
import { DetailValueSelectorViewModel, ValueLoader } from "../../rawData/detailValueSelector";
import  { AccountAndDetailSelectorView } from "./accountAndDetailSelector-view"

export class AccountAndDetailSelectorViewModel extends ViewModel{
    constructor(parentViewModel: ViewModel,accountLoader?:IAccountLoader,detailLoader?:ValueLoader) {
        super(parentViewModel);
        this.accountLoader = accountLoader ?? new CachedAccountLoader();
        this.detailLoader = detailLoader ?? new ValueLoader();
        this.details = ObservableArray.create<detail>();
        this.accountSelector = new AccountSelectorViewModel(this,this.accountLoader);
        this.accountSelector.onSelectionChanged = a=>{
            if(a==null){
                this.details.clear();
            }else{
                this.details.update(...a.details.map(q=>{
                    let d  = new detail(this);
                    d.assignmentId = q.assignmentId;
                    d.name = q.name;
                    d.valueSelector = new DetailValueSelectorViewModel(d,q.id,this.detailLoader);
                    return d;
                }));
            }
        }
    }
    GetDefaultView(): View <ViewModel> {
        return new AccountAndDetailSelectorView();
    }
    public getTypeId(): string {
        return "VM-36F60231-2109-4BFA-B2CF-F66807C2BD46"
    }

    private accountLoader : IAccountLoader;
    private detailLoader : ValueLoader;
    
    public set accountSelector(v: AccountSelectorViewModel) { this._accountSelector = v; } public get accountSelector(): AccountSelectorViewModel { return this._accountSelector;} private _accountSelector: AccountSelectorViewModel;
    public set details(v: ObservableArray<detail>) { this._details = v; } public get details(): ObservableArray<detail> { return this._details;} private _details: ObservableArray<detail>;
}

export class detail extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set assignmentId(v: string) { this._assignmentId = v; } public get assignmentId(): string { return this._assignmentId;} private _assignmentId: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set valueSelector(v: DetailValueSelectorViewModel) { this._valueSelector = v; } public get valueSelector(): DetailValueSelectorViewModel { return this._valueSelector;} private _valueSelector: DetailValueSelectorViewModel;
}
